export const baseUrl = 'https://cms-emmanuelle-chenais.acte.ltd'
